import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-card__labels" }
const _hoisted_2 = { class: "_flex _ai-c" }
const _hoisted_3 = { class: "_flexcol" }
const _hoisted_4 = { "format-key": "0" }
const _hoisted_5 = { "format-key": "1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_checkbox_field = _resolveComponent("checkbox-field")
  const _component_localize = _resolveComponent("localize")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.wrapperClass),
    "data-qa": "payment-type:Deposit"
  }, [
    _createElementVNode("div", {
      class: "_cur-p _pa-3 _pos-r",
      onClick: _cache[1] || (_cache[1] = $event => (_ctx.onSelectPaymentType()))
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createBlock(_component_base_badge, {
          key: _ctx.badgeProps.name,
          class: "_mr-1 _my-1",
          theme: _ctx.badgeProps.theme,
          "data-qa": `reward-card-badge:${_ctx.badgeProps.dataQa}`
        }, {
          default: _withCtx(() => [
            (_ctx.badgeProps.icon)
              ? (_openBlock(), _createBlock(_component_base_icon, {
                  key: 0,
                  name: _ctx.badgeProps.icon
                }, null, 8 /* PROPS */, ["name"]))
              : _createCommentVNode("v-if", true),
            _createTextVNode(" " + _toDisplayString(_ctx.badgeProps.name), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["theme", "data-qa"]))
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_checkbox_field, {
          modelValue: _ctx.isSelected,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.isSelected) = $event)),
          "show-label": false,
          name: "paymentTypeItem",
          class: "_mt-0 _mr-2",
          type: "radio"
        }, null, 8 /* PROPS */, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createBlock(_component_localize, {
            key: _ctx.depositAmountFormatted,
            resource: _ctx.Resources.Checkout.CheckoutPaymentTypeDepositLabel
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.depositAmountFormatted), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.depositPercentageFormatted), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["resource"]))
        ])
      ])
    ])
  ], 2 /* CLASS */))
}